import { render, staticRenderFns } from "./ghCustomFilter.vue?vue&type=template&id=325f4dfb&scoped=true&"
import script from "./ghCustomFilter.vue?vue&type=script&lang=js&"
export * from "./ghCustomFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f4dfb",
  null
  
)

export default component.exports